import {Injectable} from '@angular/core';
import {Actions,createEffect,ofType} from '@ngrx/effects';
import {SharedActions} from '../actions/action-types';
import {concatMap,map} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { configDetails } from '../actions/shared.actions';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { environment } from 'src/environments/environment';
import { SharedConsts } from '../../constants';

@Injectable()

export class SharedEffects{

    loadConfig$ = createEffect(
        ()=> this.actions$
            .pipe(
                ofType(SharedActions.loadConfigData),
                concatMap(action=>this.http.get<any>(`${environment.apiURL+SharedConsts.CONFIG_API_URL}`)),
                map((config:any)=>{
                    this.stateService.configDetails = config.response.retailer_env_details;
                    this.stateService.checkoutToken = config.response?.retailer_env_details?.checkoutToken
                    this.stateService.magentoCloudUrl = config.response?.magento_cloud_url?.cloud_front_url
                    this.stateService.isConfigSetoStore.next(true);
                    let curretUser = this.stateService.getLocalStorage('currentUser');
                    let updateUserDetails = {...curretUser,is_upload_order:config.response?.is_upload_order}
                    this.stateService.setLocalStorage('currentUser',updateUserDetails)
                    return configDetails({config_details:config.response})
                })
            )
    )


    constructor(private actions$:Actions,private http: HttpClient,private stateService:StatePersistService){

    }

}